import { map } from 'rxjs';

import { componentOutletConfigFactory } from '@recruitee/common';
import { injectTranslate } from '@recruitee/i18n';
import { EMPTY_CELL, UserCellComponent } from '@recruitee/user-interface';
import { injectUntilDestroyed } from '@recruitee/utils';

import { defineOfferTableColumn, injectUsersMap } from './utils';
import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';

export const hiringManagerColumn = defineOfferTableColumn(() => {
  const usersMap = injectUsersMap();
  return {
    id: OfferColumnId.HiringManager,
    label: injectTranslate()('app.offers.table.hiring_manager'),
    visible: false,
    geometry: {
      width: 160,
      minWidth: 120,
      autoFitProp: 'width',
    },
    options: {
      draggable: false,
      resizable: true,
      removable: true,
      sortable: false,
    },
    componentFactory: ({ row }) => {
      if (!row.hiringManagerId) return EMPTY_CELL;

      return usersMap.pipe(
        map(users =>
          componentOutletConfigFactory(UserCellComponent, {
            inputs: { user: users[row.hiringManagerId!] },
          }),
        ),
        injectUntilDestroyed(),
      );
    },
  };
});
